import { FormEvent } from 'react';
import { IValidation } from './final-xm-validation';
import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Label } from 'react-bootstrap';
import UploadFile from '@nkr/views/center-admin/billing/view-edit/upload-file';

interface IProps {
    acceptable: number,
    rootCause: string,
    correctiveAction: string,
    upload: File,
    initials: string,
    validation: IValidation,
    dirty: boolean,
    isList: boolean,
    onAcceptedChange: (acceptable: number) => void,
    onFieldChange: (field: string, value: string) => void,
    onUploadChange: (upload: File) => void
}

const UploadFinalXmContents = (props: IProps) => {
    const handleAcceptableChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        props.onAcceptedChange(parseInt(e.currentTarget.value));
    };

    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        const name = e.currentTarget.name;
        const value = name === 'initials' ? e.currentTarget.value.slice(0, 4) : e.currentTarget.value;
        props.onFieldChange(name, value);
    };

    const handleSelectFile = (file: File) => {
        props.onUploadChange(file);
    };

    return (
        <Form horizontal>
            <FormGroup validationState={props.dirty && !props.validation.acceptable ? 'error' : null}>
                <Col xs={12} lg={4} componentClass={ControlLabel}>
                    Final XM Acceptable?
                </Col>
                <Col xs={12} lg={8}>
                    <FormControl
                        componentClass='select'
                        value={props.acceptable}
                        onChange={handleAcceptableChange}
                    >
                        <option value={-1}>Please Select...</option>
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                    </FormControl>
                </Col>
                {props.dirty && !props.validation.acceptable && (
                    <Col xs={12} lg={8} lgOffset={4}>
                        <HelpBlock>This is required</HelpBlock>
                    </Col>
                )}
            </FormGroup>

            {!props.acceptable && (
                <>
                    <FormGroup validationState={props.dirty && !props.validation.rootCause ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Root Cause</Col>
                        <Col xs={12} lg={8}>
                            <FormControl
                                name='rootCause'
                                value={props.rootCause}
                                onChange={handleFieldChange}
                            />
                        </Col>
                        {props.dirty && !props.validation.rootCause && (
                            <Col xs={12} lg={8} lgOffset={4}>
                                <HelpBlock>This is required</HelpBlock>
                            </Col>
                        )}
                    </FormGroup>

                    <FormGroup validationState={props.dirty && !props.validation.correctiveAction ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Corrective Action</Col>
                        <Col xs={12} lg={8}>
                            <FormControl
                                name='correctiveAction'
                                value={props.correctiveAction}
                                onChange={handleFieldChange}
                            />
                        </Col>
                        {props.dirty && !props.validation.correctiveAction && (
                            <Col xs={12} lg={8} lgOffset={4}>
                                <HelpBlock>This is required</HelpBlock>
                            </Col>
                        )}
                    </FormGroup>
                </>
            )}

            <FormGroup validationState={props.dirty && !props.validation.upload ? 'error' : null}>
                <Col xs={12} lg={4} componentClass={ControlLabel}>
                    Upload Results:
                </Col>
                <Col xs={12} lg={8}>
                    <FormControl.Static style={{ display: props.isList ? 'flex' : null }}>
                        <UploadFile
                            elementName='finalXmFile'
                            valid={true}
                            disable={false}
                            accept='.pdf'
                            width={80}
                            onSelectFile={handleSelectFile}
                        />

                        {props.upload != null && (
                            <div style={{ marginLeft: 5, paddingTop: 3 }}>Selected File: <Label style={{ fontSize: '90%' }}>{props.upload.name}</Label></div>
                        )}
                    </FormControl.Static>
                </Col>
                {props.dirty && !props.validation.upload && (
                    <Col xs={12} lg={8} lgOffset={4}>
                        <HelpBlock>This is required</HelpBlock>
                    </Col>
                )}
            </FormGroup>

            <FormGroup style={{ marginBottom: 0 }} validationState={props.dirty && !props.validation.initials ? 'error' : null}>
                <Col xs={12} lg={4} componentClass={ControlLabel}>Initials:</Col>
                <Col xs={12} lg={8}>
                    <FormControl
                        style={{ width: 80 }}
                        name='initials'
                        value={props.initials}
                        onChange={handleFieldChange}
                    />
                </Col>
                {props.dirty && !props.validation.initials && (
                    <Col xs={12} lg={8} lgOffset={4}>
                        <HelpBlock>This is required</HelpBlock>
                    </Col>
                )}
            </FormGroup>
        </Form>
    );
}

export default UploadFinalXmContents;